import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './iconfont/iconfont.css'
import VAnimation from 'v-animation'
// import animated from 'animate.css';
import bottom from '../src/components/bottom.vue'

document.title="深之旅e路行|邂逅懂你的尊贵服务，开启品质生活之旅‌。"
// Vue.use(animated)
Vue.use(VAnimation)
Vue.component('HMbottom',bottom)
Vue.config.productionTip = false

new Vue({
  router,
  store:store,
  VAnimation,
  render: h => h(App)
}).$mount('#app')
